import { Icon } from '@iconify/react'
import styles from './LandingProfileDock.module.css'
import type {
  LandingProfileDockItem,
  LandingProfileDockTone,
} from './landing-profile-dock'

type LandingProfileDockProps = {
  items: LandingProfileDockItem[]
}

const TONE_CLASS: Record<LandingProfileDockTone, string> = {
  home: styles.toneHome,
  numbers: styles.toneNumbers,
  roulette: styles.toneRoulette,
  scratch: styles.toneScratch,
  info: styles.toneInfo,
  profile: styles.toneProfile,
  shop: styles.toneShop,
  ai: styles.toneAi,
}

export function LandingProfileDock({ items }: LandingProfileDockProps) {
  return (
    <nav className={styles.dock} aria-label="Atalhos da conta">
      <div className={styles.bar}>
        {items.map((item) => {
          const className = [
            styles.item,
            TONE_CLASS[item.tone],
            item.active ? styles.itemActive : '',
            (item.tone === 'roulette' || item.tone === 'scratch') && item.opportunityCount
              ? styles.itemOpportunity
              : '',
          ]
            .filter(Boolean)
            .join(' ')

          const content = (
            <>
              <span className={styles.glyph} aria-hidden>
                <Icon icon={item.icon} width={26} height={26} />
                {(item.tone === 'roulette' || item.tone === 'scratch') &&
                item.opportunityCount ? (
                  <span className={styles.badge}>
                    {item.opportunityCount > 99 ? '99+' : item.opportunityCount}
                  </span>
                ) : null}
              </span>
              <span className={styles.label}>{item.label}</span>
            </>
          )

          if (item.href) {
            return (
              <a
                key={item.id}
                href={item.href}
                className={className}
                aria-label={item.accessibleName}
              >
                {content}
              </a>
            )
          }

          return (
            <button
              key={item.id}
              type="button"
              className={className}
              aria-label={item.accessibleName}
              aria-current={item.active ? 'page' : undefined}
              onClick={item.onSelect}
            >
              {content}
            </button>
          )
        })}
      </div>
    </nav>
  )
}
